import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";

import commonEN from "./locales/en/common.json";
import statusEN from "./locales/en/status.json";

import statusDE from "./locales/de/status.json";
import commonDE from "./locales/de/common.json";

import statusRU from "./locales/ru/status.json";
import commonRU from "./locales/ru/common.json";

import statuszhYUE from "./locales/zh-HK/status.json";
import commonzhYUE from "./locales/zh-HK/common.json";

import statuszhTW from "./locales/zh-TW/status.json";
import commonzhTW from "./locales/zh-TW/common.json";

import statusZH from "./locales/zh/status.json";
import commonZH from "./locales/zh/common.json";

import statusNL from "./locales/nl/status.json";
import commonNL from "./locales/nl/common.json";

import statusHE from "./locales/he/status.json";
import commonHE from "./locales/he/common.json";

import statusIT from "./locales/it/status.json";
import commonIT from "./locales/it/common.json";

import statusJA from "./locales/ja/status.json";
import commonJA from "./locales/ja/common.json";

import statusPT from "./locales/pt/status.json";
import commonPT from "./locales/pt/common.json";

import statusES from "./locales/es/status.json";
import commonES from "./locales/es/common.json";

import statusFR from "./locales/fr/status.json";
import commonFR from "./locales/fr/common.json";

import statusEL from "./locales/el/status.json";
import commonEL from "./locales/el/common.json";

import statusKO from "./locales/ko/status.json";
import commonKO from "./locales/ko/common.json";

import statusDA from "./locales/da/status.json";
import commonDA from "./locales/da/common.json";

import statusTUR from "./locales/tur/status.json";
import commonTUR from "./locales/tur/common.json";

import statusNEP from "./locales/nep/status.json";
import commonNEP from "./locales/nep/common.json";

import statusFIL from "./locales/fil/status.json";
import commonFIL from "./locales/fil/common.json";

import statusARA from "./locales/ara/status.json";
import commonARA from "./locales/ara/common.json";
// the translations
const resources = {
  en: {
    common: commonEN,
    status: statusEN,
  },
  de: {
    common: commonDE,
    status: statusDE,
  },
  ru: {
    common: commonRU,
    status: statusRU,
  },
  "zh-HK": {
    common: commonzhYUE,
    status: statuszhYUE,
  },
  "zh-TW": {
    common: commonzhTW,
    status: statuszhTW,
  },
  zh: {
    common: commonZH,
    status: statusZH,
  },
  nl: {
    common: commonNL,
    status: statusNL,
  },
  he: {
    common: commonHE,
    status: statusHE,
  },
  it: {
    common: commonIT,
    status: statusIT,
  },
  ja: {
    common: commonJA,
    status: statusJA,
  },
  pt: {
    common: commonPT,
    status: statusPT,
  },
  es: {
    common: commonES,
    status: statusES,
  },
  fr: {
    common: commonFR,
    status: statusFR,
  },
  el: {
    common: commonEL,
    status: statusEL,
  },
  ko: {
    common: commonKO,
    status: statusKO,
  },
  da: {
    common: commonDA,
    status: statusDA,
  },
  tur: {
    common: commonTUR,
    status: statusTUR,
  },
  nep: {
    common: commonNEP,
    status: statusNEP,
  },

  fil: {
    common: commonFIL,
    status: statusFIL,
  },
  ara: {
    common: commonARA,
    status: statusARA,
  },
};

const i18nInstance = i18n.createInstance();

i18nInstance
  .use(LngDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    //supportedLngs: ['en', 'fr', 'de', 'zhCN', 'zh', 'nl', 'he', 'it', 'ja', 'pt', 'ru', 'es'],
    //ns: ['common', 'register', 'monitor', 'residents', 'devices', 'reports', 'settings'],

    debug: true,
    fallbackNS: ["common", "status"],

    detection: {
      order: ["querystring", "navigator"],
      lookupQuerystring: "lng",
    },

    // backend: {
    //     crossDomain: true,

    //     loadPath: path.join(__dirname + '/locales/{{lng}}/{{ns}}.json'),
    // },
    react: {
      useSuspense: false,
      wait: true,
    },
  });

export default i18nInstance;
